//import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import React, { Component } from "react";
import SubDiv from './SubDiv'
import {Collapse , Input , Label} from 'reactstrap'
import $ from 'jquery';
import './SideBar.scss';
//import 'rc-slider/assets/index.css';
//import 'rc-tooltip/assets/bootstrap.css';
import * as actionCreators from '../../Actions/Index';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import Cookies from 'universal-cookie';

var cookie = new Cookies();

class SideBar extends Component{
    constructor(props) {
        super(props);
        
    this.state = {
        navItems: [
            { title : 'CATEGORY', subItem: ["Woman", "Kids", "Man","Accessories","Home"]},
            { title : 'TYPE', subItem: ["Dress", "Trouser", "Scarf","Tops"]},
            { title : 'COLOR', subItem: ["Red", "Green", "Blue","Lilac","Pink","Yellow","Off-White","Beige","Mustard"
            ,"Grey","Gold","Brown","White","Maroon","Orange","Aqua","Coral","Black","Turquoise","Green","Peach", "Cream" ,"Rust", "Purple"]},
            { title : 'FABRIC', subItem: ["Lawn", "Khaddar", "Embroider"]},
            { title : 'DESIGN', subItem: ["Printed"]},
            { title : 'BRAND', subItem: ["Khaadi","Limelight", "Gulahmed", "JDot","Sapphire"]}
        ],
        showTitles: false,
        collapse: false,
    };
    }
    filterClick = (event) => {

        var color = [];
        var category = [];
        var fabric = [];
        var brand = [];
        var design = [];
        var type = [];
        var max = 0;
        var min = 0;
        $("input:checkbox[name=CATEGORY]:checked").each(function () {
            category.push($(this).val());
        });
        $("input:checkbox[name=TYPE]:checked").each(function () {
            type.push($(this).val());
        });
        $("input:checkbox[name=COLOR]:checked").each(function () {
            color.push($(this).val());
        });
        $("input:checkbox[name=FABRIC]:checked").each(function () {
            fabric.push($(this).val());
        });
        $("input:checkbox[name=BRAND]:checked").each(function () {
            brand.push($(this).val());
        });
        $("input:checkbox[name=DESIGN]:checked").each(function () {
            design.push($(this).val());
        });
        max = $("input[name=price]:checked").val();
      
    if(max == 2000){
         min = 1000;
    }
    if(max == 3000){
         min = 2000;
    }
    if(max == 4000){
        min = 3000;
    }
    if(max == 4001){
        min = 4000;
        max = 5000000;
    }
    if(!max){
          max = 500000;
         
    }
    
        
              var cat = { 
              "ProductCategory":category,
              "ProductType":type,  
              "Color":color,
              "BrandName":brand,
               "Fabric":fabric,
               "Design":design,
               "PageNo": 40,
		        "Min":min,
                "Max":max,
                "UserID":cookie.get("usfid")
          };

          this.props.getUserOrders(cat);
              
    }

    toggle = () => {
        this.setState(state => ({ collapse: !state.collapse }));
      }
      componentWillMount(){
        this.unlisten = this.props.history.listen((location, action) => {
          
        });
       
      
      }
      componentWillReceiveProps(nextProps){
        this.setState({cat:nextProps.cat});
    }
    render() {
        let expanded = this.props.expanded;
        return(
        <div className="side_nav_parent_wrapper" id="style-3" style={{ width: `${expanded ? "20%": "0px"}`, minWidth: `${expanded ? "20%": "0px"}`,display: `${expanded ? "": 'none'}`}}>
           {this.state.navItems.map(item =>{
                return(
               <SubDiv item={item.title} subItem={item.subItem} onChange={this.filterClick} />    
              )})}
               <div className="itemSpan">
                  <div  className="collapse-click"onClick={this.toggle}> PRICE
                  <span className="collapse-icon" style={{ display: `${this.state.collapse ? "none": ""}`}}>+</span>
                  <span className="collapse-icon" style={{ display: `${this.state.collapse ? "": "none"}`}}>-</span>
                  </div>
              <Collapse isOpen={this.state.collapse}>
              <div className="collapse-item" style={{lineHeight: '1.7',marginLeft: '21px'}}>
              <span style={{}}> <Label  className="subItemSpan" check>
                <Input type="radio" value='1000' name='price' onChange={this.filterClick}/>{'     '}PKR0-PKR1,000 
               </Label></span>
               <span style={{padding: "0px"}}> <Label  className="subItemSpan" check>
               <Input type="radio" value='2000' name='price' onChange={this.filterClick}/>PKR1,000-PKR2,000 
               </Label></span>
               <span style={{padding: "0px"}}> <Label  className="subItemSpan" check>
                <Input type="radio" value='3000' name='price' onChange={this.filterClick}/>PKR2,000-PKR3,000 
               </Label></span>
               <span style={{padding: "0px"}}> <Label  className="subItemSpan" check>
                <Input type="radio" value='4000' name='price' onChange={this.filterClick}/>PKR3,000-PKR4,000 
               </Label></span>
               <span style={{padding: "0px"}}> <Label  className="subItemSpan" check>
                <Input type="radio" value='4001' name='price' onChange={this.filterClick}/>PKR4,000 and above 
               </Label></span>

               </div>
               </Collapse>
               </div>
        </div>
        );
    } 
} 
const mapStateToProps=(state)=>(

    {
    productsList:state.productsList,
    cat:state.cat,
  });
  
  const mapDispatchToProps = dispatch => {
    return {
      getUserOrders: (cat) => dispatch(actionCreators.getUserOrders(cat)),
    }
    
  }
export default withRouter(connect(mapStateToProps,mapDispatchToProps)(SideBar)) 